export default __webpack_public_path__ + "static/media/moussakamissoko.491f2051.png";